export class AllRotorsError extends Error {
  data?: any;
  readonly code = AllRotorsError.name;
  constructor(message: string, data?: any) {
    super(message);
    this.data = data;
    this.name = AllRotorsError.name;
  }
}
